export default __webpack_public_path__ + "static/media/StevenSchultzResume.16874ea9.pdf";